module.exports = __webpack_public_path__ + "static/media/plaid-min-min.a489974e.png";